<template>
  <div>
    <section class="p-4 max-w-7xl mx-auto">
      <h2 class="text-3xl text-gray-700 font-bold lg:text-center te p-4 lg:text-3xl text-[20px] sm:text-[20px]">
        Frequently Asked Questions
      </h2>
      <div class="lg:flex lg:gap-4">
        <div>
          <div data-accordion="collapse" class="text-left">
            <h2 id="accordion-collapse-heading-1" class="pt-4 text-left text-left moreBox">
              <button
                class="flex items-start justify-between w-80 md:w-[480px] xl:w-[600px] mx-auto px-5 py-3 border border-gray-200 rounded-xl bg-white dark:bg-white"
                id="b0" data-accordion-target="#accordion-collapse-body-1" aria-expanded="false"
                aria-controls="accordion-collapse-body-1">
                <span class="text-black text-left">Who should opt for this elective?</span>
                <img src="../assets/about/read-more.png" width="20" alt="" />
              </button>
            </h2>
            <div id="accordion-collapse-body-1" class="hidden" aria-labelledby="accordion-collapse-heading-1">
              <div
                class="p-5 border border-t-0 border-gray-200 w-80 md:w-[480px] xl:w-[600px] mx-auto rounded-b-xl bg-white">
                <p class="mb-2">
                  Students interested in careers in taxation, auditing, corporate finance, compliance, consulting, or
                  financial planning will find this elective highly beneficial.
                </p>
              </div>
            </div>
            <h2 id="accordion-collapse-heading-2" class="pt-4 text-left moreBox">
              <button
                class="flex items-start justify-between w-80 md:w-[480px] xl:w-[600px] mx-auto p-5 border border-gray-200 rounded-xl bg-white dark:bg-white"
                id="b1" data-accordion-target="#accordion-collapse-body-2" aria-expanded="false"
                aria-controls="accordion-collapse-body-2">
                <span class="text-black text-left">What skills will I gain through this elective?</span>
                <img src="../assets/about/read-more.png" width="20" alt="" />
              </button>
            </h2>
            <div id="accordion-collapse-body-2" class="hidden" aria-labelledby="accordion-collapse-heading-2">
              <div
                class="p-5 border border-t-0 border-gray-200 w-80 md:w-[480px] xl:w-[600px] mx-auto rounded-b-xl bg-white">
                <p class="mb-2 text-left">
                  You will develop expertise in financial reporting, tax planning, audit methodologies, financial
                  modeling, business law, compliance, and strategic decision-making.
                </p>
              </div>
            </div>
            <h2 id="accordion-collapse-heading-3" class="pt-4 text-left moreBox">
              <button
                class="flex items-start justify-between w-80 md:w-[480px] xl:w-[600px] mx-auto p-5 border border-gray-200 rounded-xl bg-white dark:bg-white"
                id="b2" data-accordion-target="#accordion-collapse-body-3" aria-expanded="false"
                aria-controls="accordion-collapse-body-3">
                <span class="text-black text-left">Are there practical components included in the course?</span>
                <img src="../assets/about/read-more.png" width="20" alt="" />
              </button>
            </h2>
            <div id="accordion-collapse-body-3" class="hidden" aria-labelledby="accordion-collapse-heading-3">
              <div
                class="p-5 border border-t-0 border-gray-200 w-80 md:w-[480px] xl:w-[600px] mx-auto rounded-b-xl bg-white">
                <p class="mb-2 text-left">
                  Yes. The elective includes applications of financial modeling, decision-making tools, compliance
                  frameworks, and real-world case-based learning.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div>
          <div data-accordion="collapse">
            <h2 id="accordion-collapse-heading-4" class="pt-4 text-left moreBox lg:block hidden">
              <button
                class="flex items-start justify-between w-80 md:w-[480px] xl:w-[600px] mx-auto p-5 border border-gray-200 rounded-xl bg-white dark:bg-white"
                id="b3" data-accordion-target="#accordion-collapse-body-4" aria-expanded="false"
                aria-controls="accordion-collapse-body-4">
                <span class="text-black text-left">What makes this elective different from general finance
                  electives?</span>
                <img src="../assets/about/read-more.png" width="20" alt="" />
              </button>
            </h2>
            <div id="accordion-collapse-body-4" class="hidden" aria-labelledby="accordion-collapse-heading-4">
              <div
                class="p-5 border border-t-0 border-gray-200 w-80 md:w-[480px] xl:w-[600px] mx-auto rounded-b-xl bg-white">
                <p class="mb-2 text-left">
                  Unlike broad finance tracks, this elective offers specialized depth in taxation, auditing, compliance,
                  and financial strategy—ideal for students seeking domain-specific expertise.
                </p>
              </div>
            </div>
            <h2 id="accordion-collapse-heading-5" class="pt-4 text-left moreBox lg:block hidden">
              <button
                class="flex items-start justify-between w-80 md:w-[480px] xl:w-[600px] mx-auto p-5 border border-gray-200 rounded-xl bg-white dark:bg-white"
                id="b4" data-accordion-target="#accordion-collapse-body-5" aria-expanded="false"
                aria-controls="accordion-collapse-body-5">
                <span class="text-black text-left">Do I need a strong background in accounting to choose this
                  elective?</span>
                <img src="../assets/about/read-more.png" width="20" alt="" />
              </button>
            </h2>
            <div id="accordion-collapse-body-5" class="hidden" aria-labelledby="accordion-collapse-heading-5">
              <div
                class="p-5 border border-t-0 border-gray-200 w-80 md:w-[480px] xl:w-[600px] mx-auto rounded-b-xl bg-white">
                <p class="mb-2 text-left">
                  A basic understanding of accounting principles is helpful, but the curriculum is structured to support
                  progressive learning for all students.
                </p>


              </div>
            </div>

          </div>
        </div>
        <div class="flex justify-center mt-4">
          <div class="flex align-middle place-content-end gap-2 lg:hidden" id="loadMore">

            <button class="readmore-btn text-gray-600"><a href="#">View More</a></button><img
              src="../assets/about/read-more.png" width="25" alt="">
          </div>
        </div>
      </div>
    </section>
  </div>
</template>



<script>
import $ from "jquery";
export default {

  mounted() {
    $(document).ready(function () {
      $(".moreBox").slice(0, 3).show();
      if ($(".accordion-item:hidden").length != 0) {
        $("#loadMore").show();
      }
      $("#loadMore").on("click", function (e) {
        e.preventDefault();
        $(".moreBox:hidden").slice(0, 4).slideDown();
        if ($(".moreBox:hidden").length == 0) {
          $("#loadMore").fadeOut("slow");
        }
      });
    });
  },
}


</script>

<style>
.moreBox,
.moreBox1 {
  font-size: 17px !important;
  font-weight: 400 !important;
}
</style>
